








import {Component, Vue} from 'vue-property-decorator';
import {i18nMixin} from '../../modules/neodash/mixins';

@Component({
    name: 'HomeButtonComponent'
})
export default class HomeButtonComponent extends Vue{
    public readonly translate = i18nMixin.methods.i18n;

    public goBack() {
        this.$router.push({
            name: 'home'
        });
    }
}
